import { Helmet } from "react-helmet";

const CompareLifeInsurance = () => {
  return (
    <>
      <Helmet>
        <title>Best Life insaurance policy</title>
      </Helmet>
      <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
        {/* ==================== Sticky section ================= */}
        <section>
          <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
            <h2 className="text-xl font-bold text-white text-center">
              Get Project Estimation
            </h2>
            <form className="mt-6 lg:mt-3">
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                type="text"
                placeholder="Name"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                type="email"
                placeholder="Email"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                type="number"
                placeholder="Phone number"
              />
              <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                <option disabled="" selected="">
                  Select Budget
                </option>
                <option>USD 2000 - USD 5000</option>
                <option>USD 5000 - USD 10000</option>
                <option>USD 10000 - USD 20000</option>
                <option>USD 20000 - USD 40000</option>
                <option>USD 40000 - USD 60000</option>
                <option>USD 60000 - USD 90000</option>
                <option>USD 90000 - USD 130000</option>
                <option>USD 130000 - USD 200000</option>
                &gt;
              </select>
              <textarea
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                placeholder="message"
                rows={3}
                defaultValue={""}
              />
              <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                Submit
              </button>
            </form>
          </div>
        </section>
        <section>
          {/* ================ Hero section ================= */}
          <section className="mt-8">
            <div
              style={{ backgroundImage: 'url("image/life-i.jpg")' }}
              className="bg-no-repeat h-[70vh] bg-center md:h-[80vh] rounded-lg flex flex-col items-center justify-center bg-black bg-blend-overlay bg-opacity-30"
            >
              <h1 className="text-5xl font-bold text-white text-center">
                Get Best Life Insurance
              </h1>
              <p className=" text-white mt-4 text-center">
                We've teamed up with top insurers to deliver affordable life
                insurance <br className="hidden md:block" /> meant to protect
                your beneficiaries from financial hardship.
              </p>
              <a
                href="#text"
                className="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-blue rounded-xl group mt-5"
              >
                <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-[#297dc2] rounded group-hover:-mr-4 group-hover:-mt-4">
                  <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white" />
                </span>
                <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-[#2e8ddb] rounded-2xl group-hover:mb-12 group-hover:translate-x-0" />
                <span className="relative w-full text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">
                  Button Text
                </span>
              </a>
            </div>
          </section>
          {/* ============ Text section ================ */}
          <section id="text" className="mt-16 md:mt-32">
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-2xl font-bold text-black">
                How life insurance works
              </h2>
              <p className="my-6">
                While the exact process might vary slightly from insurer to
                insurer, there are five steps that you can typically expect when
                applying for life insurance:
              </p>
              <ul className="list-decimal ms-8">
                <li className="my-3">
                  <span className="font-bold">
                    Submit an initial application.
                  </span>
                  In order to obtain life insurance, you must qualify by
                  submitting an initial application that covers general
                  information (e.g. proof of identity, contact information,
                  proof of financial situation), your personal and familial
                  medical history (e.g. surgical history, medical diagnoses),
                  and your lifestyle (e.g. smoking habits, hazard level of your
                  occupation). This applies whether you're in Dubai, UAE, United
                  Arab Emirates, Abu Dhabi, Sharjah, Al Ain, Ajman, Ras Al
                  Khaimah, Fujairah, or Umm Al Quwain.
                </li>
                <li className="my-3">
                  <span className="font-bold">
                    Participate in a phone screening.
                  </span>
                  After your initial application is reviewed, they'll often
                  follow up with a phone call where they confirm the provided
                  information and discuss more questions related to your health
                  and lifestyle.{" "}
                </li>
                <li className="my-3">
                  <span className="font-bold">Receive a medical exam.</span>
                  While not required by all insurance policies, many require an
                  additional medical examination. This can include everything
                  from the basics of weight and height to blood tests and even
                  drug tests. This process is standard whether you're located in
                  Dubai, UAE, United Arab Emirates, Abu Dhabi, Sharjah, Al Ain,
                  Ajman, Ras Al Khaimah, Fujairah, or Umm Al Quwain.
                </li>
                <li className="my-3">
                  <span className="font-bold">Wait.</span>Your insurance company
                  will also likely perform a soft credit check, pull your motor
                  vehicle report, and check your prescription history. This and
                  the previously gathered information will be used in the
                  underwriting process to determine your final rating.{" "}
                </li>
                <li className="my-3">
                  <span className="font-bold">
                    Confirm and sign your policy.
                  </span>
                  If no other issues arise, then you just need to confirm and
                  sign your policy!
                </li>
              </ul>
              <p className="my-6">
                Remember, once you finalize how much life insurance you need and
                your rate, you must keep paying your premium to keep the
                coverage in place.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-12">
              <h2 className="text-2xl font-bold text-black">
                How does life insurance work when I die?
              </h2>
              <p className="my-6">
                After you pass away, your beneficiary must file a claim with the
                life insurance company and submit relevant documentation, such
                as a death certificate. The beneficiary may choose how the death
                benefit will be paid out to them — either via lump sum or annual
                payments. Each life insurance payment option is paid out
                tax-free.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-12">
              <h2 className="text-2xl font-bold text-black">
                Types of life insurance policies
              </h2>
              <p className="my-6">
                Another factor to consider — aside from how much insurance you
                need — is what life insurance options are best for you and your
                family members. The two primary differences between these types
                of life insurance policies are the length of coverage over your
                lifetime and the potential to increase your death benefit over
                time via cash value.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-12">
              <h2 className="text-2xl font-bold text-black">
                Permanent life insurance policies
              </h2>
              <p className="my-6">
                Permanent policies remain in effect for your entire life (or at
                least as long as your premiums are paid). They also offer the
                benefit of building cash value. While often used interchangeably
                with "whole life insurance," cash value life insurance also
                encompasses other permanent life insurance policies such as
                universal life insurance. <br />
                <br />
                With cash value life insurance, a percentage of every premium
                payment you make is diverted as tax-deferred cash value that
                accrues interest at the rate specified on your policy. This is
                separate from the death benefit and is available to be used
                while the policyholder is still living. Beneficiaries should not
                expect to receive both in the event of the policyholder’s death.
                Think of it as a savings account built into your whole life
                policy.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-12">
              <h2 className="text-2xl font-bold text-black">
                Is life insurance tax-deductible?
              </h2>
              <p className="my-6">
                Life insurance premiums are generally not tax-deductible. One of
                the rare exceptions is business owners, who can deduct life
                insurance premiums paid for employees. However, this comes with
                a few more provisions; for example, you cannot deduct premiums
                if you own the business with your spouse and the business must
                not be named as a beneficiary on the policy.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-12">
              <h2 className="text-2xl font-bold text-black">
                Are death benefits taxable?
              </h2>
              <p className="my-6">
                The death benefits payout beneficiaries receive is not
                considered taxable income. If your family is expected a death
                benefit of $1 million after you pass, they can expect the full
                amount. Many policyholders strategically plan to pay future
                family expenses tax-free — including college tuition or mortgage
                payments — by enrolling in life insurance.
              </p>
            </div>
          </section>
        </section>
      </main>
    </>
  );
};

export default CompareLifeInsurance;
